import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: 'ホーム', path: '/' },
  { label: 'サービス紹介', path: '/services' },
  { label: '料金プラン', path: '/pricing' },
  { label: '会社概要', path: '/about' },
  { label: 'お問い合わせ', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const handleTopNavigation = (path: string) => {
    if (path === '/') {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled || !isHome
          ? 'bg-[#0f1628]/95 backdrop-blur-sm border-b border-[#c9a84c]/20'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <Link to="/" onClick={() => handleTopNavigation('/')} className="flex flex-col items-start cursor-pointer">
          <span className="font-serif-jp text-[#c9a84c] text-xs tracking-[0.3em] font-light">GODO KAISHA</span>
          <span className="font-serif-jp text-white text-lg md:text-xl tracking-[0.2em] font-medium leading-tight">合同会社ＡＺ</span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => handleTopNavigation(item.path)}
              className={`nav-link font-sans text-sm tracking-widest transition-colors duration-300 whitespace-nowrap ${
                location.pathname === item.path
                  ? 'text-[#c9a84c]'
                  : 'text-white/80 hover:text-white'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        {/* CTA Button */}
        <Link
          to="/contact"
          onClick={() => handleTopNavigation('/contact')}
          className="hidden md:flex items-center gap-2 border border-[#c9a84c] text-[#c9a84c] px-5 py-2 text-xs tracking-widest font-sans hover:bg-[#c9a84c] hover:text-[#0f1628] transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-mail-line text-sm"></i>
          お問い合わせ
        </Link>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <span className={`block w-6 h-px bg-white transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
          <span className={`block w-6 h-px bg-white transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`}></span>
          <span className={`block w-6 h-px bg-white transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden bg-[#0f1628]/98 border-t border-[#c9a84c]/20 transition-all duration-300 overflow-hidden ${
          menuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <nav className="flex flex-col px-6 py-4 gap-4">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => handleTopNavigation(item.path)}
              className={`font-sans text-sm tracking-widest py-2 border-b border-white/10 whitespace-nowrap cursor-pointer ${
                location.pathname === item.path ? 'text-[#c9a84c]' : 'text-white/80'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
}
